<template>
    <div class="variables mx-auto">
        <b-container>
            <b-card class="bg-white">
                <b-breadcrumb class="bg-white" :items="this.breadcrumb_items"></b-breadcrumb>
                <b-col class="col">
                    <b-card border-variant="light" class="shadow vh-100">
                        <b-form @submit="submit" class="p-2">
                            <b-form-group
                                label-cols-sm="4"
                                label-cols-lg="3"
                                label-for="input-horizontal"
                                label="Office Address">
                                <b-form-input id="text" name="office_address" placeholder="Office Address"
                                              required
                                              v-model="variable_data.office_address1">
                                </b-form-input>
                            </b-form-group>

                            <b-form-group
                                label-cols-sm="4"
                                label-cols-lg="3"
                                label-for="input-horizontal"
                                label="Office Address2">
                                <b-form-input id="text" name="office_address2" placeholder="Office Address 2"
                                              required
                                              v-model="variable_data.office_address2">
                                </b-form-input>
                            </b-form-group>

                            <b-form-group
                                label-cols-sm="4"
                                label-cols-lg="3"
                                label-for="input-horizontal"
                                label="Office Address City">
                                <b-form-input id="text" name="office_address_city" placeholder="Office City"
                                              required
                                              v-model="variable_data.office_address_city">
                                </b-form-input>
                            </b-form-group>

                            <b-form-group
                                label-cols-sm="4"
                                label-cols-lg="3"
                                label-for="input-horizontal"
                                label="Office Address State">
                                <b-form-input id="text" name="office_address_state"
                                              placeholder="Office State"
                                              required
                                              v-model="variable_data.office_address_state">
                                </b-form-input>
                            </b-form-group>

                            <b-form-group
                                label-cols-sm="4"
                                label-cols-lg="3"
                                label-for="input-horizontal"
                                label="Office Address Zip">
                                <b-form-input id="text" name="office_address_zip" placeholder="Office Zip"
                                              required
                                              v-model="variable_data.office_address_zip">
                                </b-form-input>
                            </b-form-group>


                            <b-form-group
                                label-cols-sm="4"
                                label-cols-lg="3"
                                label-for="input-horizontal"
                                label="Facebook Link">
                                <b-form-input id="text" name="fb_link" placeholder="Facebook Link" required
                                              v-model="variable_data.fb_link">
                                </b-form-input>
                            </b-form-group>

                            <b-form-group
                                label-cols-sm="4"
                                label-cols-lg="3"
                                label-for="input-horizontal"
                                label="Instagram Link">
                                <b-form-input id="text" name="instagram_link" placeholder="Instagram Link"
                                              required
                                              v-model="variable_data.instagram_link">
                                </b-form-input>
                            </b-form-group>

                            <b-form-group
                                label-cols-sm="4"
                                label-cols-lg="3"
                                label-for="input-horizontal"
                                label="Office Phone">
                                <b-form-input id="phone" name="office_phone" placeholder="Office Phone" required
                                              v-model="variable_data.office_phone">
                                </b-form-input>
                            </b-form-group>

                            <hr/>

                            <b-form-group
                                label-cols-sm="4"
                                label-cols-lg="3"
                                label-for="input-horizontal"
                                label="Default Email">
                                <b-form-input id="email" name="default_email" placeholder="Default Email"
                                              required
                                              v-model="variable_data.default_email">
                                </b-form-input>
                            </b-form-group>

                            <b-form-group
                                label-cols-sm="4"
                                label-cols-lg="3"
                                label-for="input-horizontal"
                                label="About Statement">
                                <b-form-textarea id="phone" name="about" placeholder="About Statement" rows="4"
                                                 required
                                                 v-model="variable_data.about">
                                </b-form-textarea>
                            </b-form-group>

                            <b-button type="submit" variant="primary" @click.stop="submit">Submit</b-button>
                        </b-form>
                    </b-card>
                </b-col>
            </b-card>
            <!-- Loading element -->
            <div id="loading" class="loading" v-if="isLoading">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </b-container>
    </div>
</template>

<script>
export default {
    name: 'variables',

    data() {
        return {
            isLoading: false,
            variable_data: null,
            breadcrumb_items: [
                {
                    'text': 'Home',
                    'href': "/"
                },
                {
                    'text': "My Dashboard",
                    'href': "/admin/dashboard"
                },
                {
                    'text': "Edit Site Variables",
                    'href': "#"
                },
            ],
        }
    },
    created() {
        this.getVariables();
        this.isLoading = false;
    },
    methods: {
        getVariables() {
            axios.get('/api/variables')
                .then(response => {
                    this.variable_data = response.data;
                });
        },
        toast(message, variant) {
            this.$bvToast.toast(message, {
                title: variant,
                variant: variant,
                solid: true
            })
        },
        submit(evt) {
            evt.preventDefault();
            let _self = this;
            let endpoint = '/api/variables';
            let data = {
                variables: _self.variable_data
            };
            _self.isLoading = true;
            axios.put(endpoint, data)
                .then(function (response) {
                    if (response.data.status === false) {
                        _self.isLoading = false;
                        _self.toast('There has been an issue updating variables!', 'danger');
                    } else {
                        _self.isLoading = false;
                        _self.toast('Variables have been updated!', 'success');
                        location.reload();
                    }
                });
        }
    },
}
</script>

<style lang="scss">
#loading {
    background: rgba(255, 255, 255, 0.6);
    position: fixed;
    height: 100vh;
    width: 100vw;
    z-index: 10010;
    top: 0;
    left: 0;
    text-align: center;
}

#loading i {
    Position: absolute;
    Top: 50%;
    Transform: translateY(-50%);
}

</style>
